module.exports = __webpack_public_path__ + "img/img-home2@2x.014f6a21.png";